__turbopack_context__.v({
  "shareButton": "SocialShareButtons-module-scss-module__UjNY6G__shareButton",
  "shareIcons": "SocialShareButtons-module-scss-module__UjNY6G__shareIcons",
  "socialShareContainer": "SocialShareButtons-module-scss-module__UjNY6G__socialShareContainer",
});
